module.exports = __webpack_public_path__ + "static/media/logo.f100f664.png";